<template>
  <b-modal v-model="isVisible" centered cancel-disabled no-close-on-esc
    no-close-on-backdrop hide-header-close :title="$t('consolidate-modal.title')" @show="loadBillableEntities">
    <div class="text-center">
      <div v-if="isBillable">
        <p>{{ $t('consolidate-modal.charge-with-data') }}</p>
        <base-select v-model="selectedBillingEntity" :disabled="noChargeSelectedReasonIsTechnicalType" :placeholder="$t('consolidate-appointment-modal.select-billable-entity')" :options="billingEntities"></base-select>
        <base-checkbox v-model="noChargeCheckboxValue" :onInput="noChargeToggled">
          {{ $t('consolidate-appointment-modal.no-charge') }}
        </base-checkbox>
        <base-select v-model="noChargeSelectedReason" :placeholder="$t('consolidate-appointment-modal.select-no-charge-reason')" :options="noChargeOptions" v-show="noChargeCheckboxValue"></base-select>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100">
        <base-button white shadow @click="consolidate">{{ $t('continue') }}</base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BRow } from 'bootstrap-vue'
import { TECHNICAL_REASONS } from '@/constants/db/cancelationReasons'

export default {
  components: {
    BModal,
    BRow,
    'base-checkbox': () => import('@/components/base/forms/BaseCheckbox.vue'),
    'base-select': () => import('@/components/base/forms/BaseSelect.vue'),
    'base-button': () => import('@/components/base/buttons/BaseButton.vue')
  },
  props: {
    value: [Boolean],
    isBillable: {
      type: Boolean,
      required: false,
      default: false
    },
    billingEntity: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selectedBillingEntity: null,
      noChargeCheckboxValue: false,
      noChargeOptions: [],
      noChargeSelectedReason: null,
      billingEntities: []
    }
  },
  methods: {
    consolidate () {
      this.visible = false
      if (this.isBillable && !this.noChargeCheckboxValue && !this.selectedBillingEntity) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-select-billable-entity'))
      } else if (this.isBillable && this.noChargeCheckboxValue && !this.noChargeSelectedReason) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-specify-not-charge-reason'))
      } else {
        this.$emit('consolidate', {BillingEntityId: this.selectedBillingEntity, NoChargeReasonId: this.noChargeSelectedReason})
      }
    },
    noChargeToggled () {
      if (!this.noChargeCheckboxValue && this.noChargeOptions.length === 0) {
        this.$api('NoChargeReasons').then((response) => {
          this.noChargeOptions = response.data.data
        })
      }
    },
    loadBillableEntities () {
      if (this.billingEntities.length === 0) {
        this.$api('webapp/BillingEntities').then((response) => {
          this.billingEntities = response.data.data
          if (this.billingEntity) {
            const matched = this.billingEntities.find(x => x.value === this.billingEntity)
            if (matched) this.selectedBillingEntity = matched.value
          }
        })
      }
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    noChargeSelectedReasonIsTechnicalType () {
      return TECHNICAL_REASONS.includes(parseInt(this.noChargeSelectedReason)) || this.billingEntity != null
    }
  }
}
</script>

<style lang="scss">

.modal-content {
  transition: all linear 2.5s;
}

</style>


// WEBPACK FOOTER //
// src/components/webapp/shared/ConsolidateAppointmentModal.vue